export default __webpack_public_path__ + "static/URWDIN-Medium-cbcbcb3b7d397347b8f1b7ab5d4dd79e.woff";